import { BucketDef } from './bucket-def';
import { BucketingStrategy } from './bucketing-strategy';
import { BaseBucketingStrategy } from './base-bucketing-strategy';

export class ALMLongTermBucketing extends BaseBucketingStrategy implements BucketingStrategy {
    constructor(todayStr: string, expandFirstBucket?: boolean) {
        super(todayStr, expandFirstBucket);
    }

    initBucketDefs(): void {
        this.bucketDefs.push(new BucketDef(this.today.clone().add(1, 'days'), this.startOfNextBucket(), true, '1D'));
        this.bucketDefs.push(new BucketDef(this.today.clone().add(1, 'week'), this.startOfNextBucket(), true, '1W'));
        this.bucketDefs.push(new BucketDef(this.today.clone().add(2, 'week'), this.startOfNextBucket(), true, '2W'));
        this.bucketDefs.push(new BucketDef(this.today.clone().add(4, 'week'), this.startOfNextBucket(), true, '4W'));
        this.bucketDefs.push(new BucketDef(this.addMonths(this.today, 3, true), this.startOfNextBucket(), true, '3M'));
        this.bucketDefs.push(new BucketDef(this.addMonths(this.today, 6, true), this.startOfNextBucket(), true, '6M'));
        this.bucketDefs.push(new BucketDef(this.addMonths(this.today, 12, true), this.startOfNextBucket(), true, '1Y'));
        this.bucketDefs.push(new BucketDef(this.addMonths(this.today, 12 * 3, true), this.startOfNextBucket(), true, '3Y'));
        this.bucketDefs.push(new BucketDef(this.addMonths(this.today, 12 * 5, true), this.startOfNextBucket(), true, '5Y'));
        this.bucketDefs.push(new BucketDef(this.addMonths(this.today, 12 * 50, true), this.startOfNextBucket(), true, 'Longterm'));
    }

    strategyName(): string {
        return 'ALMLongTerm';
    }

    getAllBucketTenors(): string[] {
        return this.bucketDefs
            .map((bd: BucketDef) => {
                if (bd.bucketName === 'Longterm') {
                    return '50Y';
                } else {
                    return bd.bucketName;
                }
            });
    }
}
